import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import LocalStorageService, { LocalStorageKeys } from "../services/localStorageService";

interface OtpGuardProps {
  isLoginPending: boolean;
  children: ReactNode;
}

const OtpGuard: React.FC<OtpGuardProps> = ({  children }) => {

const isLoginPending= !!LocalStorageService.get<boolean>(LocalStorageKeys.IS_LOGIN_PENDING);
  if (isLoginPending) {  
    return <>{children}</>; // allow OTP page
  }
  return <Navigate to="/login" replace />;
};

export default OtpGuard;



